import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  alert: {
    alignItems: 'center',
    fontSize: '14px',
    fontWeight: 'bold',
    border: `1px solid ${theme.palette.dashboard.main}`,
    color: theme.palette.dashboard.main,
  },

  // Para deixar o ícone da mesma cor do texto
  alertIcon: {
    filter:
      'brightness(0) saturate(100%) invert(31%) sepia(99%) saturate(401%) hue-rotate(168deg) brightness(91%) contrast(97%)',
  },
}))

export default useStyles
